import gerenciamentoEnvioRepository from './gerenciamentoEnvioRepository'
import parametrizacaoRepository from './parametrizacaoRepository'
import relatorioEnvioRepository from './relatorioEnvioRepository'

export default baseUrl => {
    return {
        gerenciamentoEnvio: gerenciamentoEnvioRepository(baseUrl),
        parametrizacao: parametrizacaoRepository(baseUrl),
        relatorioEnvio: relatorioEnvioRepository(baseUrl),
    }
}
